const FormResources = {

        form_data:
        {
            associate_id: [],
            supervisor_associate_id: [],
            shift_id: [],
            shift_class_id: [],
            group_id: [],
            census: '',
            days_per_week: '',
            days_per_week_simbol: 1,
        },

        options: [
            {
                id: 1,
                name: 'Yes'
            },
            {
                id: 0,
                name: 'No'
            }
        ],

        class_shift_options: [
        { id: 1, name: "Day" },
        { id: 2, name: "Evening" },
        { id: 3, name: "Night" },
        ],
    
        form_format:
        [
            {
                css_class:  'col-md-2',
                type:       'infinite-scroll-list',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Supervisor:',
                model_name: 'supervisor_associate_id',
                ref:        'supervisor_associate_id_input',
                ref_alt:    'supervisor_associate_id_input_alt',
                required:   false,
                search: false,
                parent_class: 'custom-control custom-checkbox w-100',
                input_type: 'checkbox',
                input_class: 'custom-control-input',
                label_input_class: 'custom-control-label reports__show-hide__label ml-2',
                placeholder: 'Select supervisor(s)',
                close_on_option: false,
                track_by: 'name'
            },
            {
                css_class:  'col-md-2',
                type:       'infinite-scroll-list',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Associate:',
                model_name: 'associate_id',
                ref:        'associate_id_input',
                ref_alt:    'associate_id_input_alt',
                required:   false,
                search: false,
                parent_class: 'custom-control custom-checkbox w-100',
                input_type: 'checkbox',
                input_class: 'custom-control-input',
                label_input_class: 'custom-control-label reports__show-hide__label ml-2',
                placeholder: 'Select associate(s)',
                close_on_option: false,
                track_by: 'associate_name'
            },
            {
                css_class:  'col-md-2',
                type:       'infinite-scroll-list',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Shift:',
                model_name: 'shift_id',
                ref:        'shift_id_input',
                ref_alt:    'shift_id_input_alt',
                required:   false,
                search: false,
                parent_class: 'custom-control custom-checkbox w-100',
                input_type: 'checkbox',
                input_class: 'custom-control-input',
                label_input_class: 'custom-control-label reports__show-hide__label ml-2',
                placeholder: 'Select shift(s)',
                close_on_option: false,
                track_by: 'name'
            },
            {
                css_class:  'col-md-2',
                type:       'infinite-scroll-list',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Class Shift:',
                model_name: 'shift_class_id',
                ref:        'shift_class_id_input',
                ref_alt:    'shift_class_id_input_alt',
                required:   false,
                search: false,
                parent_class: 'custom-control custom-checkbox w-100',
                input_type: 'checkbox',
                input_class: 'custom-control-input',
                label_input_class: 'custom-control-label reports__show-hide__label ml-2',
                placeholder: 'Select class shift(s)',
                close_on_option: false,
                track_by: 'name'
            },
            {
                css_class:  'col-md-2',
                type:       'infinite-scroll-list',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Group:',
                model_name: 'group_id',
                ref:        'group_id_input',
                ref_alt:    'group_id_input_alt',
                required:   false,
                search: false,
                parent_class: 'custom-control custom-checkbox w-100',
                input_type: 'checkbox',
                input_class: 'custom-control-input',
                label_input_class: 'custom-control-label reports__show-hide__label ml-2',
                placeholder: 'Select group(s)',
                close_on_option: false,
                track_by: 'name'
            },
            {
                css_class:  'col-md-2',
                type:       'select',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Include in Census:',
                model_name: 'census',
                ref:        'census_input',
                ref_alt:    'census_input_alt',
                required:   false,
            },
            {
                css_class:  'col-md-2',
                type:       'number',
                maxlength:  '',
                disabled:   false,
                step:       '',
                name:       'Days per Week:',
                model_name: 'days_per_week',
                ref:        'days_per_week_input',
                ref_alt:    'days_per_week_input_alt',
                required:   false,
            },
    
        ],
}

export default FormResources